import { createClient } from '@supabase/supabase-js'

// Vérifier que les variables d'environnement sont définies
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Les clés Supabase ne sont pas configurées. Vérifiez votre fichier .env.local')
}

// Créer le client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Helper pour vérifier si l'utilisateur est connecté
export const isAuthenticated = async () => {
  const { data: { session } } = await supabase.auth.getSession()
  return !!session
}

// Helper pour récupérer l'utilisateur actuel
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser()
  return user
}

// Helper pour récupérer le profil de l'utilisateur
export const getUserProfile = async (userId) => {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single()

  if (error) throw error
  return data
}
